import request from '@/router/axios'
import env from '@/config/env'

// 渠道数据报表
export function userDateAll(data) {
  return request({
    url: env.ferryUrl + '/user-source/data/all',
    method: 'post',
    data
  })
}

// 渠道数据报表
export function userDatePage(data) {
  return request({
    url: env.ferryUrl + '/user-source/data/page',
    method: 'post',
    data
  })
}

// 渠道列表
export function userDateList() {
  return request({
    url: env.ferryUrl + '/user-source/manage/list',
    method: 'get'
  })
}
